<template>
  <div class="assessment">
    <AppBar />
    <div class="page-content">
      <div class="assessment-canvas">
        <div class="assessment-background">
          <img :src="top.imgBack" alt="" />
        </div>
        <div class="por-container">
          <div class="solution-info">
            <div class="solution-info-title">{{ top.title }}</div>
            <div class="solution-info-content" v-html="top.content">
              <!-- 利用在线招聘流程，帮助企业实现智能、便捷的招聘模式，
              建立企业自己的人才储备机制 -->
            </div>
          </div>
        </div>
      </div>
      <div ref="nav" class="assessment-nav">
        <div ref="navTabs" class="assessment-tabs" :style="{width: navWidth+'%', height: navHeight+'px'}">
          <div
            v-for="(item, index) in navList"
            :key="index"
            :class="['assessment-nav-item', topNaviId === item.id ? 'top-nav-item' : '']"
            @click="goAnchor(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div>
        <div ref="pain-points" class="pain-points">
          <div class="title">企业人才测评的痛点</div>
          <div class="pain-points-list">
            <div
              v-for="(item, index) in painPointsList"
              :key="index"
              class="pain-points-list-item"
            >
              <div>
                <div class="list-item-card">
                  <div class="list-item-icon-wrap">
                    <img
                      :src="item.icon"
                      alt=""
                      class="list-item-icon"
                    />
                  </div>
                  <div class="list-item-text">
                    <div class="list-item-title">
                      {{ item.title }}
                    </div>
                    <div class="list-item-des">
                      {{ item.describe }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref="sense-of-worth">
        <div style="width: 100%; height: 60px; background-color: #f7f9fc;"></div>
        <div class="sense-of-worth">
          <div class="title">产品价值体现</div>
          <div class="sense-of-worth-list">
            <div
              v-for="(item, index) in senseOfWorthList"
              :key="index"
              class="sense-worth-list-item"
            >
              <div class="list-item-img-box">
                <img :src="item.img" alt="" class="list-item-img" />
              </div>
              <div class="list-item-text-box">
                <div class="list-item-title">
                  {{ item.title }}
                </div>
                <div class="list-item-describe">
                  {{ item.describe }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="solution" class="solution">
          <div class="title">人才测评解决方案</div>
          <div v-if="solutionContentList.length != 0" class="solution-content">
            <div class="solution-tag">
              <div
                v-for="(item, index) in solutionContentList"
                :key="index"
                class="solution-tag-item"
                :class="{'display-tag-item': index === solutionTagActiveIndex}"
                @click="displayTag(index)"
              >
                <div class="tag-item-title">
                  <div class="title-text">{{ item.title }}</div>
                  <img v-if="index !== solutionTagActiveIndex" :src="require('@/assets/cloudplatform/icon/right-arrow.png')" alt="" />
                  <img v-else :src="require('@/assets/cloudplatform/icon/down-arrow.png')" alt="" />
                </div>
                <div class="tag-item-describe">
                  <div
                    class="describe"
                  >
                    {{ item.describe }}
                  </div>
                </div>
              </div>
            </div>
            <transition name="solution-fade">
              <div :key="solutionTagActiveIndex" class="fade-content">
                <img :src="solutionContentList[solutionTagActiveIndex].img" alt="" />
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import { getColumnChild, getColumnDetail } from '@/api/column';
import { getContentList, getContentDetail } from '@/api/content';

export default {
  name: 'AssessMent',
  data () {
    return {
      top: {
        title: '',
        content: '',
        imgBack: require('@/assets/assessment/canvas.gif'),
      },
      navWidth: 80,
      navHeight: 60,
      offsetTop: 0,
      scrollTop: 0,
      position: 0,
      topNaviId: null,
      navList: [
        {
          title: '企业痛点',
          id: 'pain-points',
        },
        {
          title: '产品价值观',
          id: 'sense-of-worth',
        },
        {
          title: '解决方案',
          id: 'solution',
        },
      ],
      painPointsList: [
        // {
        //   title: '与岗位要求匹配度不高',
        //   icon: require('@/assets/assessment/icon/pain-points1.png'),
        //   describe: '只能简单的根据岗位要求招聘，无法从人员“性格”“特长”“发展要求”等多个维度更深层次定位岗位需求。',
        // },
        // {
        //   title: '无法甄别适合企业发展的人才',
        //   icon: require('@/assets/assessment/icon/pain-points2.png'),
        //   describe: '利用测评报告协助管理者，识别适合企业发展的关键岗位人才,根据职位需求及企业组织特性对其素质状况、发展潜力、个性特点等心理特征作出科学地评价。',
        // },
        // {
        //   title: '没有人才特性分析，不能支撑人员调整',
        //   icon: require('@/assets/assessment/icon/pain-points3.png'),
        //   describe: '人员调整没有数据依据，需要从主观判断转换成从客观事实依据来进行岗位调整，帮助企业建立更好的人才应用生态。',
        // },
        // {
        //   title: '不能帮助管理者工作开展',
        //   icon: require('@/assets/assessment/icon/pain-points4.png'),
        //   describe: '测评系统能够帮助管理者迅速的了解雇员的实际能力，并为人员培训提供诊断性信息。',
        // },
      ],
      senseOfWorthList: [
        // {
        //   title: '人员配置',
        //   describe: '可以对个体的兴趣、人格、能力、技能等多方面进行分析，为实现人才的合理安置提供信息',
        //   img: require('@/assets/assessment/sense-of-worth1.png'),
        // },
        // {
        //   title: '人员开发',
        //   describe: '运用人才测评可以判断员工各方面为工作所需要的素质，描述其素质结构，为制定有效的培训方案提供依据',
        //   img: require('@/assets/assessment/sense-of-worth2.png'),
        // },
        // {
        //   title: '人员考核',
        //   describe: '人才测评能够提供关于个体的行为的描述，形成对被测者的全面的评价，从而为人事考核提供依据',
        //   img: require('@/assets/assessment/sense-of-worth3.png'),
        // },
        // {
        //   title: '人员晋升',
        //   describe: '借助人才测评，可以使组织管理者对晋升的候选人进行考察，降低人事决策的风险',
        //   img: require('@/assets/assessment/sense-of-worth4.png'),
        // },
      ],
      solutionContentList: [
        // {
        //   title: '心理测量',
        //   describe: '主要是对员工心理现象的测量，包括能力、兴趣、性格、气质及价值观等，这是由心理素质在员工发展事业成功过程的关键性作用所决定的',
        //   img: require('@/assets/assessment/solution1.png'),
        // },
        // {
        //   title: '抽样测量',
        //   describe: '人才测评的对象是素质及绩效，但素质和绩效不是单独表现于某个事件或时间段，所以需要根据实际情况进行抽样测量，综合评估。',
        //   img: require('@/assets/assessment/solution2.png'),
        // },
        // {
        //   title: '相对测量',
        //   describe: '鉴别评价不一定完全符合对象的实际情况，测评结果既反映被测者素质的基本状态，但与被测者真实素质都有一定程度的偏离，所以对结果的采纳使用相对原则。',
        //   img: require('@/assets/assessment/solution3.png'),
        // },
      ],
      solutionTagActiveIndex: 0,
    };
  },
  watch: {
    scrollTop(newValue, oldValue) {
      setTimeout(() => {
        if (newValue === window.scrollY) {
          for (var i = 0; i < this.navList.length; i++) {
            var elementTop = this.$refs[`${this.navList[i].id}`].offsetTop - this.scrollTop - 1;
            if (elementTop <= 70) {
              this.topNaviId = this.navList[i].id;
            }
          }
        }
      }, 20);
    },
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
    this.$nextTick(() => {
      const nav = this.$refs.nav;
      this.offsetTop = nav.offsetTop;
    });
    this.getPageColumn();
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      var offsetHeight = this.$refs.navTabs.offsetHeight;
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var headerFixed = this.scrollTop > this.offsetTop - offsetHeight / 2 - 70;
      var scroll = this.scrollTop - this.position;
      this.position = this.scrollTop;
      if (this.scrollTop <= 400) {
        this.navHeight = 52;
        this.navWidth = 80;
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (this.scrollTop >= 400 && !headerFixed) {
        this.navHeight += 0.04 * scroll;
        this.navWidth += 0.12 * scroll;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (headerFixed) {
        this.navHeight = 60;
        this.navWidth = 100;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'fixed';
        this.$refs.nav.style.top = offsetHeight / 2 + 70 + 'px';
      }
    },
    goAnchor(i) {
      // var id = '#' + i.id;
      // document.querySelector(id).scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start',
      // });
      window.scrollTo({
        top: this.$refs[`${i.id}`].offsetTop - 70,
        left: 0,
        behavior: 'smooth',
      });
    },

    // 获取页面栏目
    async getPageColumn() {
      const params = { parentId: '1607260450788171776', };
      getColumnChild(params).then(async (res) => {
        const { result, } = res;
        for (var i = 0; i < result.length; i++) {
          if (result[i].name === '企业痛点') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                const rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                var painPointsItem = {
                  title: rtsult.title,
                  icon: rtsult.icon,
                  describe: rtsult.description,
                };
                this.painPointsList.push(painPointsItem);
              }
            });
          } else if (result[i].name === '产品价值观') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            this.valueCenterImg = result[i].icon;
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var senseOfWorthItem = {
                  title: rrsult.data[j].title,
                  describe: rrsult.data[j].description,
                  img: rrsult.data[j].icon,
                };
                // const rts = await getContentDetail(rrsult.data[j].id);
                // const rtsult = rts.result;
                // for (var x = 0; x < rtsult.elements.length; x++) {
                //   senseOfWorthItem.textList.push(rtsult.elements[x].content);
                // }
                this.senseOfWorthList.push(senseOfWorthItem);
              }
            });
          } else if (result[i].name === '解决方案') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var solutionContentItem = {
                  title: rrsult.data[j].title,
                  describe: rrsult.data[j].description,
                  img: rrsult.data[j].icon,
                };
                // const rts = await getContentDetail(rrsult.data[j].id);
                // const rtsult = rts.result;
                // for (var x = 0; x < rtsult.elements.length; x++) {
                //   solutionItem.contentList.push(rtsult.elements[x].content);
                // }
                this.solutionContentList.push(solutionContentItem);
              }
            });
          } else if (result[i].name === '顶部图') {
            getColumnDetail(result[i].id).then((rrs) => {
              const rrsult = rrs.result;
              var content = rrsult.elements.find(obj => obj.name === 'content').content;
              var contentdoc = new DOMParser().parseFromString(content, 'text/html');
              this.top.title = rrsult.elements.find(obj => obj.name === 'subtitle').content;
              this.top.content = contentdoc.documentElement.textContent.replace(/&nbsp;/g, ' ');
              // this.top = {
              //   imgBack: rrsult.icon,
              // };
            });
          }
        }
      });
    },

    // onmousemove(i) {
    //   this.painPointsIndex = i;
    // },
    displayTag(index) {
      this.solutionTagActiveIndex = index;
    },
    openBealter () {
      this.$refs.altProduct.tobealter();
    },
    openBealter2() {
       this.$refs.ast.drawer  = true
    },
  },
};
</script>

<style lang="less" scoped>
.assessment{
  background-color: #fff;
  .page-content{
      width: 100%;
      .assessment-canvas{
            width: 100%;
            height: fit-content;
            min-width: var(--minwidth);
            position: relative;
            background-size: cover;
            overflow: hidden;
            .assessment-background{
                position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-position: top;
        background-size: cover;
        background-repeat: no-repeat;
                img{
                    width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center top;
                }
            }
            .por-container {
        width: 70%;
        max-width: 1200px;
        margin: 0 auto;
        position: relative;
        .solution-info {
          width: 480px;
          height: 560px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          box-sizing: border-box;
          .solution-info-title {
            font-size: 45px;
            font-weight: bold;
            line-height: 55px;
            color: #fff;
            margin-bottom: 29px;
          }
          .solution-info-content {
            font-size: 20px;
            line-height: 32px;
            color: #fff;
            margin-bottom: 44px;
          }
          // .solution-btn {
          //   width: 142px;
          //   height: 48px;
          //   background-color: #1589fd;
          //   color: #fff;
          //   text-align: center;
          //   line-height: 48px;
          //   cursor: pointer;
          //   border-radius: 24px;
          // }
        }
      }
      }
      .assessment-nav{
        width: 100%;
        display: flex;
        position: relative;
        justify-content: center;
        z-index: 50;
        .assessment-tabs{
          margin: 0 auto;
          box-shadow: 0px 2px 8px 0px rgba(139, 139, 139, 0.18);
          border-radius: 2px;
          background-color: #fff;
          display: flex;
          position: absolute;
          top: -26px;
          .assessment-nav-item{
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #181818;
          font-size: 14px;
          cursor: pointer;
        }
        .assessment-nav-item:hover{
          color: #00b0dc;
        }
        .top-nav-item {
          color: #fff;
          background-color: #00b0dc;
        }
        .top-nav-item:hover {
          color: #fff;
        }
        }
      }
      .pain-points{
        width: 100%;
        padding-top: 115px;
        padding-bottom: 30px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #f7f9fc;
        .title{
            font-size: 32px;
            color: #181818;
            line-height: 1;
            margin-bottom: 70px;
        }
        .pain-points-list{
          width: 1200px;
          height: 393px;
          margin: 0 auto;
          background-color: #fff;
          border-radius: 4px;
          box-shadow: 0px 2px 8px 0px rgba(139, 139, 139, 0.12);
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-items: center;
          .pain-points-list-item{
            width: 50%;
            height: 50%;
            padding: 50px 50px 0 30px;
            box-sizing: border-box;
            .list-item-card{
              width: 100%;
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              .list-item-icon-wrap{
                width: 64px;
                display: flex;
                justify-content: center;
                .list-item-icon{
                  width: auto;
                  height: 46px;
                  display: block;
                }
              }
              .list-item-text{
                margin-left: 16px;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                .list-item-title{
                  font-size: 18px;
                  color: #181818;
                  line-height: 1;
                  margin-bottom: 17px;
                }
                .list-item-des{
                  width: 440px;
                  font-size: 16px;
                  color: #6d6e6f;
                }
              }
            }
          }
        }
      }
      .sense-of-worth{
        width: 1200px;
        margin: 0 auto;
        margin-top: 90px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        .title{
          font-size: 32px;
          color: #181818;
        }
        .sense-of-worth-list{
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-top: 70px;
          .sense-worth-list-item{
            width: 282px;
            height: 446px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            background-color: #fff;
            border-radius: 10px;
            border: 1px solid #eee;
            box-shadow: 0px 3px 24px 0px rgba(139, 139, 139, 0.1);
            transform: translateY(0);
            transition: all .3s ease-in-out;
            .list-item-img-box{
              flex: 1;
              display: flex;
              justify-content: center;
              align-items: center;
              .list-item-img{
                width: auto;
              }
            }
            .list-item-text-box{
              width: 195px;
              height: 197px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: flex-start;
              .list-item-title{
                font-size: 26px;
                font-weight: 600;
                line-height: 1;
                color: #181818;
                margin-bottom: 29px;
              }
              .list-item-describe{
                text-align: center;
                font-size: 14px;
                font-weight: 400;
                color: #6d6e6f;
              }
            }
          }
          .sense-worth-list-item:hover{
            transform: translateY(-15px);
          }
        }
      }
      .solution{
        width: 1200px;
        padding-top: 109px;
        padding-bottom: 90px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .title{
          font-size: 32px;
          color: #181818;
          line-height: 1;
          padding-bottom: 90px;
          box-sizing: border-box;
        }
        .solution-content{
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .solution-tag{
            width: 440px;
            height: 455px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .solution-tag-item{
              width: 100%;
              height: 83px;
              padding: 31px;
              margin-bottom: 16px;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              box-sizing: border-box;
              background-color: #f5f7f9;
              border-radius: 8px;
              cursor: pointer;
              transition: all .3s ease-in-out;
              .tag-item-title {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                transition: all .3s ease-in-out;
                margin-bottom: 20px;
                .title-text{
                  font-weight: 600;
                  font-size: 18px;
                  color: #181818;
                  transition: all .3s ease-in-out;
                }
              }
              .tag-item-describe{
                width: 100%;
                flex: 1;
                overflow: hidden;
                .describe{
                  font-size: 16px;
                  font-weight: 300;
                  color: #181818;
                  line-height: 25px;
                  transition: all .3s ease-in-out;
                }
              }
            }
            .display-tag-item{
              height: 230px;
              background: url('@/assets/cloudplatform/introduction-tag.png') no-repeat;
              background-size: cover;
              .tag-item-title{
                .title-text{
                  color: #fff;
                }
              }
              .tag-item-describe{
                .describe{
                  color: #fff;
                }
              }
            }
            .solution-tag-item:last-child{
              margin: 0;
            }
          }
          .fade-content{
            width: 740px;
            height: 455px;
            img{
              width: 100%;
              display: block;
            }
          }
          .solution-fade-enter-active{
            animation: bounce-in 0.5s;
          }
          .solution-fade-leave-active{
            animation: bounce-in 0s reverse;
          }
          @keyframes bounce-in {
            0% {
                opacity: 0;
            }
            100% {
                opacity: 1;
            }
          }
        }
      }
  }
}
</style>
